/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
import { types } from "mobx-state-tree"

/**
 * Typescript enum
 */

export enum RouteSolutionExportOrder {
  ROUTE_ID="ROUTE_ID",
NAME="NAME",
PLANNED_START_TIME="PLANNED_START_TIME"
}

/**
* RouteSolutionExportOrder
*/
export const RouteSolutionExportOrderEnumType = types.enumeration("RouteSolutionExportOrder", [
        "ROUTE_ID",
  "NAME",
  "PLANNED_START_TIME",
      ])
